export const addFaqData = [
    {
        placeholder:'Question',
        required:true,
        type:'text',
        name:'question',
        label:'Question',
    },
    {
        placeholder:'Answer',
        required:true,
        type:'textarea',
        name:'answer',
        label:'Answer',
        multiline: true,
        row: 4,   
    }
]